/* eslint-disable max-lines */
import {
  POST_FIELDS,
  OPERATION,
  SAC_STATUS_FIELDS,
  SAC_SURVEYS_FIELDS,
  ENTITIES,
  VALUE_TYPES,
} from '@/services/charts-service';

import {
  DEFAULT_SIZES,
  DATA_TYPE,
  WIDTH,
  HEIGHT,
  FILTER_NAMES,
  COMPONENT_TYPE,
} from '@/store/modules/cards/constants';
import { Flags } from '@/plugins/rollout';

const proprietaryPostsFilter = { sac_type: { value: ['Post', 'Reels', 'Story'] } };
const sacStatus = { sac_status: { value: ['Respondido', 'Fechado', 'Em Espera'] } };
const sacLastStatus = { sac_last_status: { value: ['Aberto', 'Pendente'] } };

/*
  Property of allowCards objects:

  id: String,
  width: Enum DEFAULT_SIZES,
  height: Enum DEFAULT_SIZES,
  component: String,
  visible: Boolean,
  hideExpandButton: Boolean,
  hideResizeButton: Boolean,
  notSupportFilter: Boolean,
  dataType: Enum DATA_TYPE,
  props: Object,
*/
export default [
  {
    id: 'SAC_1',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'SacReportCallsQuantity',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Transições por Status de Atendimento',
      originalTitle: 'Transições por Status de Atendimento',
      isExpandedCard: false,
      description: 'Tabela com o total de transições feitas entre os status de atendimento no período de tempo selecionado.',
      tags: 'Atendimento',
    },
  },
  {
    id: 'SAC_2',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'TimelineProprietaryPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Timeline de Publicações Proprietárias',
      originalTitle: 'Timeline de Publicações Proprietárias',
      isExpandedCard: false,
      description: 'Lista ordenada por data (mais recente) das publicações feitas pelos perfis cadastrados (inclui posts e interações feitas pelas páginas).',
      tags: 'Menções e Publicações',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_3',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropInteractionsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Engajamento Recebido',
      originalTitle: 'Engajamento Recebido',
      isExpandedCard: false,
      description: 'Somatória de todas as ações de engajamento recebidas a partir de publicações proprietárias filtradas na pesquisa.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_4',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropLikesTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Curtidas Recebidas',
      originalTitle: 'Curtidas Recebidas',
      isExpandedCard: false,
      description: 'Somatória de todas as curtidas recebidas a partir de publicações proprietárias e filtradas na pesquisa.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_5',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropCommentsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Comentários Recebidos',
      originalTitle: 'Comentários Recebidos',
      isExpandedCard: false,
      description: 'Somatória de todos os comentários recebidos a partir de publicações proprietárias realizadas no período selecionado e filtradas na pesquisa.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_6',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropPostsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Posts e Interações',
      originalTitle: 'Posts e Interações',
      isExpandedCard: false,
      description: 'Contagem de publicações das páginas conectadas e filtradas na pesquisa. Mostra publicações proprietárias por padrão, mas pode ser ajustado para mostrar todos os tipos de interação.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_7',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropImpressionsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Impressões',
      originalTitle: 'Impressões',
      isExpandedCard: false,
      description: 'Somatória do total de impressões orgânicas e pagas a partir de publicações proprietárias e filtradas na pesquisa.',
      tags: 'Performance',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_8',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropReachTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Alcance',
      originalTitle: 'Alcance',
      isExpandedCard: false,
      description: 'Somatória do total de alcance conquistado a partir de publicações proprietárias e filtradas na pesquisa.',
      tags: 'Performance',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_9',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropVideoViewsTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Views',
      originalTitle: 'Views',
      isExpandedCard: false,
      description: 'Somatória das visualizações de vídeos nos canais proprietários existentes na pesquisa e filtrados.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_10',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropImpressionTimeSeries',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Impressões no Tempo',
      originalTitle: 'Impressões no Tempo',
      isExpandedCard: false,
      description: 'Somatória do total de impressões orgânicas e pagas a partir de publicações proprietárias e filtradas na pesquisa disposta no período de tempo selecionado.',
      tags: 'Performance',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_11',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropReachTimeSeries',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Alcance no Tempo',
      originalTitle: 'Alcance no Tempo',
      isExpandedCard: false,
      description: 'Somatória do total de alcance conquistado a partir de publicações proprietárias e filtradas na pesquisa disposta no período de tempo selecionado.',
      tags: 'Performance',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_12',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropInteractionsTimeSeries',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Engajamento Recebido no Tempo',
      originalTitle: 'Engajamento Recebido no Tempo',
      isExpandedCard: false,
      description: 'Somatória de todas as ações de engajamento recebidas a partir de publicações proprietárias filtradas na pesquisa disposta no período de tempo selecionado.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_13',
    width: WIDTH.LARGE,
    height: HEIGHT.XLARGE,
    component: 'PropTopPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Publicações com mais engajamento',
      originalTitle: 'Publicações com mais engajamento',
      isExpandedCard: false,
      description: 'Cards em forma de lista contendo conteúdo proprietário ordenado pelo total de engajamento conquistado.',
      tags: 'Menções e Publicações',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_14',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropSentimentTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_AREA,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento das Interações no tempo',
      originalTitle: 'Sentimento das Interações no tempo',
      isExpandedCard: false,
      description: 'Distribuição das interações recebidas por sua polaridade ao longo de um período de tempo.',
      tags: 'Sentimento; Engajamento',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_15',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropSentimentGauge',
    componentType: COMPONENT_TYPE.GAUGE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Termômetro de Sentimento das interações',
      originalTitle: 'Termômetro de Sentimento das interações',
      isExpandedCard: false,
      description: 'Representa o resultado da equação: (publicações positivas / publicações coletadas * 100) - (publicações negativas / publicações coletadas * 100) aplicada apenas para interações recebidas.',
      tags: 'Sentimento; Engajamento',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_16',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropChannelInTimeChart',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Engajamento por canal no tempo',
      originalTitle: 'Engajamento por canal no tempo',
      isExpandedCard: false,
      description: 'Distribuição das interações recebidas divididas por canal proprietário ao longo de um período de tempo.',
      tags: 'Engajamento; Canais',
    },
  },
  {
    id: 'SAC_17',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropCollectedUsers',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Usuários interagindo',
      originalTitle: 'Usuários interagindo',
      isExpandedCard: false,
      description: 'Contagem de usuários únicos que interagiram com os canais proprietários.',
      tags: 'Usuários e Influenciadores; Engajamento',
    },
  },
  {
    id: 'SAC_18',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento por Canal Proprietário',
      originalTitle: 'Sentimento por Canal Proprietário',
      isExpandedCard: false,
      description: 'Distribuição de publicações (posts + interações) pelos canais proprietários e sua divisão por polaridade.',
      tags: 'Sentimento; Canais',
      group: POST_FIELDS.CHANNEL,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_19',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento por Tag Proprietária',
      originalTitle: 'Sentimento por Tag Proprietária',
      isExpandedCard: false,
      description: 'Distribuição de publicações (posts + interações) pelas tags atribuídas e sua divisão por polaridade.',
      tags: 'Sentimento; Categorias e Anotações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_20',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento das Interações por Gênero',
      originalTitle: 'Sentimento das Interações por Gênero',
      isExpandedCard: false,
      description: 'Distribuição de interações por Gênero e sua divisão por polaridade',
      tags: 'Sentimento; Demográficos',
      group: POST_FIELDS.GENDER,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_21',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.HORIZONTAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento por Temas',
      originalTitle: 'Sentimento por Temas',
      isExpandedCard: false,
      description: 'Distribuição de publicações (posts + interações) pelos temas da pesquisa e sua divisão por polaridade.',
      tags: 'Sentimento; Categorias e Anotações',
      group: POST_FIELDS.THEME,
      filterName: FILTER_NAMES.THEME,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_22',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'PropSentimentPie',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Distribuição de Sentimento das Interações',
      originalTitle: 'Distribuição de Sentimento das Interações',
      isExpandedCard: false,
      description: 'Divisão das interações por polaridade positiva, negativa ou neutra.',
      tags: 'Sentimento; Engajamento',
    },
    control: {
      tiktok: {
        hideInChannel: false,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_23',
    width: WIDTH.LARGE,
    height: HEIGHT.XLARGE,
    component: 'PropTopCommentsPosts',
    componentType: COMPONENT_TYPE.CARD,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Publicações Proprietárias Mais Comentadas',
      originalTitle: 'Publicações Proprietárias Mais Comentadas',
      isExpandedCard: false,
      description: 'Cards em forma de carrossel contendo conteúdo proprietário ordenado pelo total de comentários recebidos.',
      tags: 'Menções e Publicações ; Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_24',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'PropChannelPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Interações por canal',
      originalTitle: 'Interações por canal',
      isExpandedCard: false,
      description: 'Distribuição do volume das interações recebidas divididas por canal proprietário.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'SAC_25',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropUserFrequency',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Interações por usuário',
      originalTitle: 'Interações por usuário',
      isExpandedCard: false,
      description: 'Razão entre o número de interações dividido pela quantidade de usuários interagindo.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'SAC_26',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropSentimentTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Sentimento das interações no tempo percentual',
      originalTitle: 'Sentimento das interações no tempo percentual',
      isExpandedCard: false,
      description: 'Distribuição das interações recebidas pela proporção percentual de positivas, negativas e neutras ao longo de um período de tempo.',
      tags: 'Sentimento ; Engajamento',
      dataType: 'percent',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_27',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.VERTICAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'Atendimentos por Operadores',
      originalTitle: 'Atendimentos por Operadores',
      isExpandedCard: false,
      description: 'Distribuição percentual do volume de atendimentos realizados por cada operador.',
      tags: 'Atendimento',
      label: 'Total de Ações',
      operation: OPERATION.COUNT,
      group: SAC_STATUS_FIELDS.userName,
      entity: ENTITIES.SAC_STATUS,
      hideNull: true,
      polarity: false,
      stackLabels: 'percentage',
    },
  },
  {
    id: 'SAC_28',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PropTotalRecontactedUsers',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Quantidade de usuários com mais de 1 Interação',
      originalTitle: 'Quantidade de usuários com mais de 1 Interação',
      isExpandedCard: false,
      description: 'Volume total de usuários que interagiram mais de uma vez com os conteúdos proprietários.',
      tags: 'Engajamento',
    },
  },
  {
    id: 'SAC_29',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.VERTICAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Distribuição por Tema (Proprietários)',
      originalTitle: 'Distribuição por Tema (Proprietários)',
      isExpandedCard: false,
      description: 'Volume de publicações ou interações nos perfis proprietários distribuídos por temas cadastrados na pesquisa.',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      group: POST_FIELDS.THEME,
      filterName: FILTER_NAMES.THEME,
      polarity: false,
      hideNull: true,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_30',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'PropBaseShareSentiment',
    componentType: COMPONENT_TYPE.VERTICAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Distribuição por Tag (Proprietários)',
      originalTitle: 'Distribuição por Tag (Proprietários)',
      isExpandedCard: false,
      description: 'Volume de publicações ou interações nos perfis proprietários distribuídos por tags atribuídas.',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
      polarity: false,
      hideNull: true,
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_31',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'FansTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.PAGE,
    props: {
      title: 'Total de fãs',
      originalTitle: 'Total de fãs',
      isExpandedCard: false,
      description: 'Total de Fãs das páginas selecionadas na data final do período pesquisado.',
      tags: 'Performance',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_32',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'NewFans',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.PAGE,
    props: {
      title: 'Novos fãs',
      originalTitle: 'Novos fãs',
      isExpandedCard: false,
      description: 'Total de fãs conquistados pelas páginas selecionadas no período pesquisado.',
      tags: 'Performance',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_33',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'FanBaseEvolutionChart',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.PAGE,
    props: {
      title: 'Evolução da Base de Fãs',
      originalTitle: 'Evolução da Base de Fãs',
      isExpandedCard: false,
      description: 'Variação diária de fãs das páginas pesquisadas no período, relativa ao dia anterior.',
      tags: 'Performance',
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_34',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'EngagementMatrix',
    componentType: COMPONENT_TYPE.BUBBLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Matriz de engajamento por publicações',
      originalTitle: 'Matriz de engajamento por publicações',
      isExpandedCard: false,
      description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações proprietárias do período. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      tags: 'Engajamento',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
  },
  {
    id: 'SAC_35',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'EngagementMatrix',
    componentType: COMPONENT_TYPE.BUBBLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Matriz de engajamento por tags',
      originalTitle: 'Matriz de engajamento por tags',
      isExpandedCard: false,
      description: 'Compara engajamento, impressões e índice de sentimento dos comentários das publicações do período, por tag. A divisão dos quadrantes é data pela média aritimética dos últimos 90 dias.',
      tags: 'Engajamento',
      type: 'tags',
      filter: {
        ...proprietaryPostsFilter,
      },
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_36',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SacTreatmentsByOperator',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Volume de atendimentos por operador',
      originalTitle: 'Volume de atendimentos por operador',
      isExpandedCard: false,
      description: 'Total de eventos contabilizados entre o “Status Antigos” e o “Status Novos”, filtrados na pesquisa por operador. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
      tags: 'Atendimento',
    },
  },
  {
    id: 'SAC_37',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SacTreatmentsByPage',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Volume de atendimentos por página',
      originalTitle: 'Volume de atendimentos por página',
      isExpandedCard: false,
      description: 'Total de eventos contabilizados entre o “Status Antigos” e o “Status Novos”, filtrados na pesquisa por página. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
      tags: 'Atendimento',
    },
  },
  {
    id: 'SAC_38',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropMetricTimeSeries',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Volume de atendimentos no tempo',
      originalTitle: 'Volume de atendimentos no tempo',
      isExpandedCard: false,
      description: 'Total de eventos contabilizados entre o “Status Antigos” e o “Status Novos”, filtrados na pesquisa no tempo. Não contabiliza conversas pendentes novas em que ainda não haja mudança de status.',
      tags: 'Atendimento',
      operation: OPERATION.COUNT,
      entity: ENTITIES.SAC_STATUS,
      label: 'Atendimentos',
    },
  },
  {
    id: 'SAC_39',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'SacTreatmentsTotalAttendances',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Total de atendimentos',
      originalTitle: 'Total de atendimentos',
      isExpandedCard: false,
      description: 'Total de eventos contabilizados entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa (OBS.: Não contabiliza novas conversas pendentes onde ainda não ocorreu mudança de status).',
      tags: 'Atendimento',
    },
  },
  {
    id: 'SAC_40',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SacAverageTimeForTreatmentsByOperator',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Tempo médio de atendimento por operador',
      originalTitle: 'Tempo médio de atendimento por operador',
      isExpandedCard: false,
      description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, por operador.',
      tags: 'Atendimento',
      filter: {
        ...sacStatus,
        ...sacLastStatus,
      },
    },
  },
  {
    id: 'SAC_41',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SacAverageTimeForTreatmentsByPage',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Tempo médio de atendimento por página',
      originalTitle: 'Tempo médio de atendimento por página',
      isExpandedCard: false,
      description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, por página.',
      tags: 'Atendimento',
      filter: {
        ...sacStatus,
        ...sacLastStatus,
      },
    },
  },
  {
    id: 'SAC_42',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PropMetricTimeSeries',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Tempo Médio de atendimento no tempo',
      originalTitle: 'Tempo Médio de atendimento no tempo',
      isExpandedCard: false,
      description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa, no tempo.',
      tags: 'Atendimento',
      metric: SAC_STATUS_FIELDS.statusChangeTime,
      operation: OPERATION.AVG,
      entity: ENTITIES.SAC_STATUS,
      label: 'Tempo médio',
      valueType: VALUE_TYPES.TIME,
      filter: {
        ...sacStatus,
        ...sacLastStatus,
      },
    },
  },
  {
    id: 'SAC_43',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'SacAverageTimeTotal',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Tempo médio de atendimento total',
      originalTitle: 'Tempo médio de atendimento total',
      isExpandedCard: false,
      description: 'Tempo médio do tempo decorrido entre os "Status Antigos" e o "Status Novos" filtrados na pesquisa.',
      tags: 'Atendimento',
      filter: {
        ...sacStatus,
        ...sacLastStatus,
      },
    },
  },
  {
    id: 'SAC_44',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'SacOperatorsTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_AREA,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Atendimentos por operadores no tempo',
      originalTitle: 'Atendimentos por operadores no tempo',
      isExpandedCard: false,
    },
  },
  {
    id: 'SAC_45',
    width: WIDTH.LARGE,
    height: HEIGHT.LARGE,
    component: 'ReportOperatorsLogs',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'Relatório de operadores',
      originalTitle: 'Relatório de operadores',
      isExpandedCard: false,
      description: 'Relatório de logs dos operadores',
    },
  },
  {
    id: 'SAC_46',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'ChangeStatus',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'Relatório de produtividade',
      originalTitle: 'Relatório de produtividade',
      isExpandedCard: false,
      description: 'Relatório de produtividade',
    },
  },
  {
    id: 'SAC_47',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BacklogTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'Tabela de Backlog',
      originalTitle: 'Tabela de Backlog',
      isExpandedCard: false,
      description: 'Tabela dos casos abertos mais antigos.',
    },
  },
  {
    id: 'SAC_48',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'SLAGaugeChart',
    componentType: COMPONENT_TYPE.GAUGE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'SLA',
      originalTitle: 'SLA',
      isExpandedCard: false,
      description: 'Conversas respondidas dentro do SLA',
    },
  },
  {
    id: 'SAC_49',
    width: WIDTH.MID,
    height: HEIGHT.SMALL,
    component: 'ProductivityCard',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Produtividade',
      originalTitle: 'Produtividade',
      isExpandedCard: false,
      description: 'Métrica de avaliação de desempenho dos atendimentos realizados pelos operadores em relação aos casos recebidos. Representa o resultado da equação (total de atendimentos realizados / total de casos recebidos * 100).',
    },
  },
  {
    id: 'SAC_50',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'ProductivityDaily',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Produtividade por dia',
      originalTitle: 'Produtividade por dia',
      isExpandedCard: false,
      description: 'Distribuição do índice de produtividade por dia ao longo do tempo. Mede a avaliação de desempenho dos atendimentos realizados pelos operadores em relação aos casos recebidos.',
    },
  },
  {
    id: 'SAC_51',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'CallsIncomingAttended',
    componentType: COMPONENT_TYPE.DUAL_AXIS,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    hideInLibrary: [Flags.showProductivityCard],
    props: {
      title: 'Volume de atendimentos recebidos x atendidos',
      originalTitle: 'Volume de atendimentos recebidos x atendidos',
      isExpandedCard: false,
      description: 'Quantidade de atendimentos recebidos em comparação aos atendidos ao longo do tempo.',
      type: 'themes',
    },
  },
  {
    id: 'SAC_52',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'OperatorsStatus',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC_STATUS,
    shareable: false,
    props: {
      title: 'Status dos Operadores',
      originalTitle: 'Status dos Operadores',
      isExpandedCard: false,
      description: 'Tabela com os status de atendimento de todos os operadores',
      selectedFilters: [FILTER_NAMES.SAC_REPLIER, FILTER_NAMES.SAC_REPLIER_STATUS],
    },
  },
  {
    id: 'SAC_53',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'ConsolidatedCSATPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    shareable: false,
    props: {
      title: 'Avaliações Consolidadas',
      originalTitle: 'Avaliações Consolidadas',
      isExpandedCard: false,
      description: 'Exibe pesquisa de satisfação do cliente por sentimento',
    },
  },

  {
    id: 'SAC_54',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'CSATBarChart',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    shareable: false,
    props: {
      title: 'Avaliações no Tempo',
      originalTitle: 'Avaliações no Tempo',
      isExpandedCard: false,
      metric: SAC_SURVEYS_FIELDS.surveyDate,
      description: 'Exibe pesquisa de satisfação do cliente',
    },
  },
  {
    id: 'SAC_55',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'CustomerServiceRatings',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC,
    shareable: false,
    props: {
      title: 'Avaliações do Atendimento',
      originalTitle: 'Avaliações do Atendimento',
      isExpandedCard: false,
      description: 'Tabela com as avaliações de atendimento realizados via smartcare.',
    },
  },
  {
    id: 'SAC_56',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'LoversTable',
    componentType: COMPONENT_TYPE.DATA_TABLE,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC,
    shareable: false,
    props: {
      title: 'Tabela de Lovers',
      originalTitle: 'Tabela de Lovers',
      isExpandedCard: false,
      description: 'Tabela de usuários mais engajados',
      selectedFilters: [FILTER_NAMES.LOVERS_HATERS, FILTER_NAMES.THEME, FILTER_NAMES.UIDS, FILTER_NAMES.TAG, FILTER_NAMES.PAGES, FILTER_NAMES.POLARITY, FILTER_NAMES.SAC_TYPE],
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      twitter: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      linkedin: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      youtube: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_57',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'InterestLovers',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: true,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Interesses dos lovers',
      originalTitle: 'Interesses dos lovers',
      isExpandedCard: false,
      description: 'Divisão de interesses encontrados nas publicações dos usuários',
      selectedFilters: [FILTER_NAMES.LOVERS_HATERS, FILTER_NAMES.UIDS, FILTER_NAMES.PAGES],
    },
    control: {
      tiktok: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      twitter: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      linkedin: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
      youtube: {
        hideInChannel: true,
        disableTag: false,
        disableTheme: false,
        disablePolarity: false,
      },
    },
  },
  {
    id: 'SAC_58',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'AverageSACTimePieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    shareable: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Tempo médio de atendimento',
      originalTitle: 'Tempo médio de atendimento',
      description: 'Tempo em cada status da conversa.',
    },
  },
  {
    id: 'SAC_59',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'PerformanceByTimeMatrix',
    componentType: COMPONENT_TYPE.BUBBLE,
    visible: true,
    shareable: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Matriz de performance dos usuários',
      originalTitle: 'Matriz de performance dos usuários',
      isExpandedCard: false,
      description: 'Matriz de performance dos usuários, detalhando a hora de atuação de cada operador',
    },
  },
  {
    id: 'SAC_60',
    width: WIDTH.LARGE,
    height: HEIGHT.MID,
    component: 'PerformanceByChannel',
    componentType: COMPONENT_TYPE.BUBBLE,
    visible: true,
    shareable: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Quantidade de atendimento por canal',
      originalTitle: 'Quantidade de atendimento por canal',
      isExpandedCard: false,
      description: 'Tabela com a quantidade de atendimento dividida por canais',
    },
  },
  {
    id: 'SAC_61',
    width: DEFAULT_SIZES.pieChart.width,
    height: DEFAULT_SIZES.pieChart.height,
    component: 'TagShareSACPieChart',
    componentType: COMPONENT_TYPE.DONUT,
    visible: true,
    shareable: false,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Publicações por tag',
      originalTitle: 'Publicações por tag',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelas tags atribuídas para dados proprietários',
      selectedFilters: [FILTER_NAMES.TAGS_VIEW],
    },
  },
  {
    id: 'SAC_62',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Publicações por Tag no Tempo',
      originalTitle: 'Publicações por Tag no Tempo',
      isExpandedCard: false,
      description: 'Distribuição de publicações pelas Tags atribuídas na pesquisa ao longo do tempo.',
      tags: 'Categorias e Anotações',
      group: POST_FIELDS.TAG,
      filterName: FILTER_NAMES.TAG,
    },
  },
  {
    id: 'SAC_63',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PostInTime',
    componentType: COMPONENT_TYPE.LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Interações no tempo',
      originalTitle: 'Interações no tempo',
      isExpandedCard: false,
      description: 'Distribuição linear das interações coletadas ao longo de um período de tempo.',
      tags: 'Menções e Interações',
    },
  },
  {
    id: 'SAC_64',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'PostByTagColumnChart',
    componentType: COMPONENT_TYPE.VERTICAL_STACKED_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Publicações por Tag',
      originalTitle: 'Publicações por Tag',
      description: 'Distribuição de publicações pelas Tags atribuídas',
      tags: 'Menções e Publicações; Categorias e Anotações',
      label: 'Publicações',
      stackLabels: 'percentage',
    },
  },
  {
    id: 'SAC_65',
    width: DEFAULT_SIZES.simpleNumber.width,
    height: DEFAULT_SIZES.simpleNumber.height,
    component: 'PostSamplingProjection',
    componentType: COMPONENT_TYPE.SINGLE_VALUE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    props: {
      title: 'Projeção amostragem de publicações',
      originalTitle: 'Projeção amostragem de publicações',
      isExpandedCard: false,
      description: 'Projeção do volume de publicações coletadas no período pesquisado, considerando a amostragem de publicações',
      dataType: 'SAC',
    },
  },
  {
    id: 'SAC_66',
    width: DEFAULT_SIZES.multiBarChart.width,
    height: DEFAULT_SIZES.multiBarChart.height,
    component: 'GoogleMyBusinessRatingsByStars',
    componentType: COMPONENT_TYPE.HORIZONTAL_BAR,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC,
    shareable: false,
    props: {
      title: 'Avaliações no Google Meu Negócio',
      originalTitle: 'Avaliações no Google Meu Negócio',
      isExpandedCard: false,
      description: 'Quantidade de avaliações por número de estrelas no canal Google Meu Negócio.',
      filter: {
        channels: {
          value: ['googlemybusiness'],
        },
      },
    },
  },
  {
    id: 'SAC_67',
    width: DEFAULT_SIZES.lineChart.width,
    height: DEFAULT_SIZES.lineChart.height,
    component: 'BaseTimeSeries',
    componentType: COMPONENT_TYPE.STACKED_LINE,
    visible: true,
    notSupportFilter: false,
    dataType: DATA_TYPE.SAC_STATUS,
    props: {
      title: 'Interações roteadas ao longo do tempo',
      originalTitle: 'Interações roteadas ao longo do tempo',
      isExpandedCard: false,
      description: 'Distribuição das interações por configuração de roteamento ao longo do tempo.',
      tags: 'Interações; Roteamento',
      group: POST_FIELDS.ROUTING_ID,
      metricLabel: 'Não roteados',
      wrapLegendLabels: true,
      filter: {
        ...sacStatus,
        ...sacLastStatus,
      },
    },
  },
];
